export class RoutePath {
    static readonly Home = { Path: '/', Label: '홈' };
    static readonly User = { Path: '/user', Label: '회원' };
    static readonly Order = { Path: '/order', Label: '출원 요청', Children: { List: { Path: '', Label: '출원 요청' }, Details: { Path: ':orderId', Label: '출원 요청 상세' } } };
    static readonly AppVersion = { Path : "/app-version", Label : "앱 버전" };
}